import { render, staticRenderFns } from "./ImportOrders.vue?vue&type=template&id=05dded52&scoped=true&"
import script from "./ImportOrders.vue?vue&type=script&lang=js&"
export * from "./ImportOrders.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrders.vue?vue&type=style&index=0&id=05dded52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dded52",
  null
  
)

export default component.exports